import { pipe } from 'rxjs'

const EVENT_HIDE_COLLAPSE = 'listGroupActive::hide::collapse'
const EVENT_UPDATE_COLLAPSE = 'bv::collapse::state'

const listGroupActive = {
  bind: function(sidebarEl, _, vnode) {
    const wrapperCollapseActive = listGroupActive.collapseActive(vnode)
    const collapseElements = pipe(
      listGroupActive.initializeCollapseParent,
      wrapperCollapseActive
    )

    collapseElements(sidebarEl)

    vnode.context.$root.$on(
      EVENT_HIDE_COLLAPSE,
      listGroupActive.onHideCollapse(sidebarEl)
    )
    vnode.context.$root.$on(EVENT_UPDATE_COLLAPSE, function(id, open) {
      const query = sidebarEl.querySelectorAll(`#${id}`)
      const el = query && query[0] ? query[0] : undefined
      const listParentId = el ? el.dataset.listParent : undefined
      const listParentQuery = listParentId
        ? sidebarEl.querySelectorAll(`#${listParentId}`)
        : undefined
      const listParent =
        listParentQuery && listParentQuery[0] ? listParentQuery[0] : undefined
      listParent &&
        (open
          ? listGroupActive.removeCollapsedClass(listParent)
          : listGroupActive.addCollapsedClass(listParent))
    })
  },
  onHideCollapse: function(sidebarEl) {
    return function(nodes) {
      nodes = nodes || [
        ...sidebarEl.querySelectorAll('[data-list-role="collapseParent"].show'),
      ]
      nodes.forEach(el => listGroupActive.addCollapsedClass(el))
    }
  },
  removeCollapsedClass: function(el) {
    el.classList.add('show')
    el.classList.remove('custom-collapsed')
  },
  addCollapsedClass: function(el) {
    el.classList.remove('show')
    el.classList.add('custom-collapsed')
  },
  initializeCollapseParent: function(sidebarEl) {
    const getNodes = [
      ...sidebarEl.querySelectorAll('[data-list-role="collapseParent"]'),
    ]
    getNodes
      .filter(el => ![...el.classList].includes('active'))
      .forEach(el => listGroupActive.addCollapsedClass(el))
    return getNodes
  },
  collapseActive: function() {
    return nodes => {
      const hasShowClass = el => [...el.classList].includes('show')
      const hasCollapsedClass = el =>
        [...el.classList].includes('custom-collapsed')
      nodes
        .filter(
          el =>
            el.dataset &&
            el.dataset.listRole === 'collapseParent' &&
            !hasShowClass(el) &&
            !hasCollapsedClass(el)
        )
        .forEach(el => {
          el.classList.add('show')
        })
      return nodes
    }
  },
}

export default listGroupActive
